/*
* @Author: Joana 'dygon' Oliveira
* @Date:   2021-01-21 11:56:24
* @Last Modified by:   Joana 'dygon' Oliveira
* @Last Modified time: 2021-10-20 08:52:02
*/

var acpt_cookies = getCookie("accept_cookies"); 

jQuery(document).ready(function() { 

    if (acpt_cookies != '') {
        jQuery('.cookie-bar-container').hide(); // hide to hide animation on loading
        // jQuery('body').removeClass('has_cookies');
    } 

    jQuery('.cookie-bar-button').click(function(event) {
        jQuery('.cookie-bar-container').addClass('hidden');
        // jQuery('body').removeClass('has_cookies');
        setCookie("accept_cookies", true, 365);
    });


});

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
